import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=e0b4ed82"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"
import style0 from "./ProfilesList.vue?vue&type=style&index=0&id=e0b4ed82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports